import { Box, Text } from "rebass/styled-components";
import { FaYoutube, FaTwitch, FaTwitter, FaInstagram } from "react-icons/fa";
import { RiTiktokFill } from "react-icons/ri";
import styled from "styled-components";

interface ISocialInputsProps {
  socials: {
    youtube: string;
    twitch: string;
    tiktok: string;
    twitter: string;
    instagram: string;
  };
  onChange: (platform: string, value: string) => void;
}

const socialPlatforms = [
  {
    key: "youtube",
    label: "YouTube",
    icon: FaYoutube,
    placeholder: "youtube.com/@",
  },
  {
    key: "twitch",
    label: "Twitch",
    icon: FaTwitch,
    placeholder: "twitch.tv/",
  },
  {
    key: "tiktok",
    label: "TikTok",
    icon: RiTiktokFill,
    placeholder: "tiktok.com/@",
  },
  {
    key: "twitter",
    label: "Twitter / X",
    icon: FaTwitter,
    placeholder: "x.com/",
  },
  {
    key: "instagram",
    label: "Instagram",
    icon: FaInstagram,
    placeholder: "instagram.com/",
  },
];

export const SocialInputs = ({ socials, onChange }: ISocialInputsProps) => {
  return (
    <Box>
      {socialPlatforms.map(({ key, label, icon: Icon, placeholder }) => (
        <InputWrapper key={key}>
          <FloatingLabel>
            <IconLabel>
              <Icon size={14} />
            </IconLabel>
            {label}
          </FloatingLabel>
          <InputContainer>
            <PlaceholderPrefix>{placeholder}</PlaceholderPrefix>
            <StyledInput
              value={socials[key as keyof typeof socials]}
              onChange={(e) => onChange(key, e.target.value)}
            />
          </InputContainer>
        </InputWrapper>
      ))}
    </Box>
  );
};

const InputWrapper = styled(Box)`
  position: relative;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const InputContainer = styled(Box)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy400};
  border: 1px solid ${({ theme }) => theme.colors.navy50};
  border-radius: 8px;
  display: flex;
  overflow: hidden;
  transition: border-color 0.2s ease;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.envy};
  }
`;

const PlaceholderPrefix = styled(Text).attrs({ as: "span" })`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy200};
  color: ${({ theme }) => theme.colors.shade200};
  display: flex;
  font-size: 14px;
  padding: 12px 4px 12px 16px;
  white-space: nowrap;
`;

const FloatingLabel = styled(Box)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy50};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.shade200};
  display: flex;
  font-size: 12px;
  font-weight: 600;
  gap: 6px;
  left: 12px;
  padding: 2px 8px;
  position: absolute;
  top: -8px;
  z-index: 1;
`;

const IconLabel = styled(Box).attrs({ as: "span" })`
  align-items: center;
  color: ${({ theme }) => theme.colors.shade200};
  display: flex;
`;

const StyledInput = styled.input`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.ice};
  flex: 1;
  font-size: 14px;
  outline: none;
  padding: 12px 16px 12px 6px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.shade100};
    opacity: 0.5;
  }
`;
